import {Config} from '../../models/config';

export const defaultConfig: Config = {
  darkMode: false,
  url_API_Sinergial: '',
  token_LocationIQ: ''
};
